import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import {
    Component,
    OnInit,
    ViewChild,
    OnDestroy,
    Inject,
    AfterViewInit,
} from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { GeneralService } from 'src/app/Service/general.service';
import Swal from 'sweetalert2';
import {
    MAT_DIALOG_DATA,
    MatDialogRef,
    MatDialog,
} from '@angular/material/dialog';
import { AddUserDistrictPopupComponent } from '../add-user-district-popup/add-user-district-popup.component';

class DataTablesResponse {
    data: any[];
    draw: number;
    recordsFiltered: number;
    recordsTotal: number;
}

@Component({
    selector: 'app-edit-district',
    templateUrl: './edit-district.component.html',
    styleUrls: ['./edit-district.component.scss'],
})
export class EditDistrictComponent implements OnInit, AfterViewInit, OnDestroy {
    breadCrumbItems: Array<{}>;
    dtOptions: DataTables.Settings = {};
    @ViewChild(DataTableDirective, { static: false })
    dtElement: DataTableDirective;
    dtTrigger = new Subject<any>();
    UserID: any;
    PlanID: any;
    isLoading: boolean = false;
    user: any;
    action: string = '';
    showDistrictList: boolean = true;

    constructor(
        private dialog: MatDialog,
        private datepipe: DatePipe,
        private gs: GeneralService,
        private http: HttpClient,
        public dialogRef: MatDialogRef<EditDistrictComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.UserID = data.userId || localStorage.getItem('UserId');
        this.PlanID = data.planId || localStorage.getItem('PlanId');
        localStorage.setItem('UserId', this.UserID);
        localStorage.setItem('PlanId', this.PlanID);
        this.action = data.action || '';

        this.breadCrumbItems = [
            { label: 'User Details', path: '/users/users-users-details' },
            { label: 'User District', path: '/', active: true },
        ];
    }

    ngOnInit() {
        this.getusersbyid();
        this.dtOptions = {
            pagingType: 'simple_numbers',
            pageLength: 10,
            processing: true,
            serverSide: true,
            ordering: true,
            searching: true,
            ajax: (dataTablesParameters: any, callback) => {
                this.http
                    .get<DataTablesResponse>(
                        `${this.gs.userDistrictList()}?UserID=${this.UserID}` +
                            `&PageNo=${
                                (dataTablesParameters.start +
                                    dataTablesParameters.length) /
                                dataTablesParameters.length
                            }` +
                            `${
                                dataTablesParameters.length != ''
                                    ? '&PageSize=' + dataTablesParameters.length
                                    : ''
                            }` +
                            `${
                                dataTablesParameters.search.value != ''
                                    ? '&search=' +
                                      dataTablesParameters.search.value
                                    : ''
                            }`
                    )
                    .subscribe((resp: any) => {
                        callback({
                            recordsTotal: resp.TotalCount,
                            recordsFiltered: resp.TotalCount,
                            data: resp.data,
                        });
                    });
            },
            columns: [
                {
                    title: 'ID',
                    data: null,
                    render: (data) => {
                        return data.UserDistrictID ? data.UserDistrictID : '--';
                    },
                },
                {
                    title: 'Entry_Date',
                    data: null,
                    render: (data) => {
                        if (
                            data.created_date === '0000-00-00' ||
                            data.created_date == null
                        ) {
                            return '--';
                        } else {
                            return this.datepipe.transform(
                                data.created_date,
                                'yyyy-MM-dd'
                            );
                        }
                    },
                },
                {
                    title: 'District Name',
                    data: null,
                    render: (data) => {
                        return data.DistrictName ? data.DistrictName : '--';
                    },
                },
                {
                    title: 'Action',
                    name: 'id',
                    orderable: false,
                    data: null,
                    render: (data) => {
                        return `<div style="display:flex">
                            <a title="Delete District">
                                <i style="margin-top: 14px; cursor:pointer; font-size: 20px; color:#c20615"
                                   class="material-icons"
                                   UserId="${data.UserDistrictID}">delete</i>
                            </a>
                        </div>`;
                    },
                },
            ],
            drawCallback: () => {
                $('.material-icons')
                    .off('click')
                    .on('click', (e) => {
                        this.delete(e.target.getAttribute('UserId'));
                    });
            },
        };
    }

    ngAfterViewInit() {
        this.dtTrigger.next();
    }

    rerender(): void {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.destroy();
            this.dtTrigger.next();
        });
    }
    onClose() {
        this.showDistrictList = false;
        this.dialogRef.close();
        // If you want to navigate after closing, you may need to inject Router and use it here
        // this.router.navigate(['/users/users-users']);
    }

    openDistrictPopup(): void {
        const dialogRef = this.dialog.open(AddUserDistrictPopupComponent, {
            width: '600px',
            height: '400px',
            disableClose: true,
            data: {
                userId: this.UserID,
                planId: localStorage.getItem('PlanId'),
            },
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result === true) {
                this.rerender();
            }
        });
    }

    district() {
        this.dialogRef.close({
            action: 'add-district',
            userId: this.UserID,
        });
    }

    delete(id: any) {
        this.isLoading = true;
        Swal.fire({
            title: 'Are you sure?',
            text: 'Do you want to delete this User District?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
        }).then((result) => {
            if (result.value) {
                this.gs.deleteUserDetail(id).subscribe(() => {
                    Swal.fire({
                        title: 'Success',
                        text: 'Data Deleted successfully.',
                        type: 'success',
                        showConfirmButton: false,
                        timer: 1500,
                    }).then(() => this.rerender());
                    this.isLoading = false;
                });
            } else {
                this.isLoading = false;
            }
        });
    }

    getusersbyid() {
        this.isLoading = true;
        this.gs.getusersbyid(this.UserID).subscribe(
            (res: any) => {
                this.user = res.data[0];
                this.user.email = this.user.EmailID.split(',');
                localStorage.setItem('PlanId', this.user.plan_id);
                this.isLoading = false;
            },
            (error) => {
                this.isLoading = false;
                Swal.fire({
                    title: error.status,
                    text: 'Internal Server Error',
                    type: 'error',
                });
            }
        );
    }

    ngOnDestroy(): void {
        this.dtTrigger.unsubscribe();
    }
}
